import { render, staticRenderFns } from "./SelectOrg.vue?vue&type=template&id=74b2dc90&scoped=true"
import script from "./SelectOrg.vue?vue&type=script&lang=js"
export * from "./SelectOrg.vue?vue&type=script&lang=js"
import style0 from "./SelectOrg.vue?vue&type=style&index=0&id=74b2dc90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b2dc90",
  null
  
)

export default component.exports